import React, {useEffect, useState} from 'react';
import Header from "../../components/header/Header";
import FooterSection from "../../components/footer/FooterSection";
import CareerStartSection from "./sections/startSection/CareerStartSection";
import OpenPositionSection from "./sections/openPositionSection/OpenPositionSection";
import InfoBlockSection from "./sections/infoBlocksSection/InfoBlockSection";
import SupportIdeasSection from "./sections/supportIdeasSection/SupportIdeasSection";
import TellAboutYouSection from "./sections/tellAboutYouSection/TellAboutYouSection";

const Careers = () => {
	const [selectedPosition, setSelectedPosition] = useState(null);

	// useEffect(() => {
	// 	window.scrollTo(0, 0)
	// }, []);

	const url = window.location.href;
	if (url.includes('#')) {
		const hash = url.split('#')[1];
		if (hash === 'introduce') {
			setTimeout(() => {
				document.getElementById('introduce')?.scrollIntoView({ behavior: 'smooth' });
			}, 1000);
		} else if (hash === 'supIdeas') {
			setTimeout(() => {
				document.getElementById('supIdeas')?.scrollIntoView({ behavior: 'smooth' });
			}, 1000);
		}
	}


	return (
		<div className={`careers`}>
			<Header mode={'dark'} />
			<CareerStartSection />
			<InfoBlockSection />
			<SupportIdeasSection />
			{/*<OpenPositionSection*/}
			{/*	setSelectedPosition={setSelectedPosition}*/}
			{/*/>*/}
			<TellAboutYouSection
				selectedPosition={selectedPosition}
				setSelectedPosition={setSelectedPosition}
			/>
			<FooterSection />
		</div>
	);
};

export default Careers;